<template>
    <v-group
            :config="groupConfig"
            @mouseover="hover(true)"
            @mouseout="hover(false)"
            @dblclick="togglePaintEnabled"
    >
        <v-image v-for="(point, i) in paintLineStrokePoints"
                 :key="i"
                 :config="{
                    x: point.x,
                    y: point.y,
                    image: brushImage,
                    rotation: point.rotation + (paintSide ? 0 : 180), // rotation uses for the no-circle brush image
                    offsetX: brushImage.width / 2,
                    offsetY: brushImage.height / 2,
                 }"
        ></v-image>
    </v-group>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: "PaintBrushStroke",

        props: [
            'brushImage',
            'paintLineStrokePoints',
            'paintEnabled',
        ],

        emits: [
            'togglePaintEnabled',
        ],

        data() {
            return {
                isHovered: false,
            }
        },

        computed: {
            ...mapState('editor', [
                'drawingState',
            ]),

            ...mapState('paint', [
                'paintSide',
            ]),

            ...mapGetters('editor', [
                'trimEditDisabled',
            ]),

            groupConfig() {
                let listening = !this.trimEditDisabled && !this.drawingState;

                return {
                    opacity: this.opacity,
                    listening,
                }
            },

            opacity() {
                let opacity = 1;

                if (this.paintEnabled) {
                    opacity = this.isHovered ? 0.5 : 1;
                }
                else {
                    opacity = this.isHovered ? 0.2 : 0;
                }

                return opacity;
            },

        },

        methods: {
            togglePaintEnabled() {
                this.$emit('togglePaintEnabled');
            },

            hover(state) {
                this.isHovered = !!state;
            },

        },

    }
</script>

<style scoped>

</style>